import {ElementsConsumer} from '@stripe/react-stripe-js';
import PaymentForm from './paymentForm';

export default function InjectedCheckoutForm() {

    return (
      <ElementsConsumer>
        {({stripe, elements}) => (
          <PaymentForm stripe={stripe} elements={elements} />
        )}
      </ElementsConsumer>
    )
  }